import { Box, Divider } from '@dixa/lib-shared-habla';

import { ThemeColor } from '../../types';

import { LauncherIcon } from './launcherIcon/LauncherIcon';
import { MessengerLogo } from './messengerLogo/MessengerLogo';
import { MessengerTheme } from './messengerTheme';

interface StyleSettingsProps {
  presetBackgrounds: ThemeColor[];
  backgroundColor: string;
  logo: string | undefined;
}

export const StyleSettings = ({
  presetBackgrounds,
  backgroundColor,
  logo,
}: StyleSettingsProps): JSX.Element => {
  return (
    <Box>
      <MessengerTheme
        presetBackgrounds={presetBackgrounds}
        backgroundColor={backgroundColor}
      />

      <Box margin="400 0">
        <Divider />
      </Box>

      <MessengerLogo logo={logo} />

      <Box margin="400 0">
        <Divider />
      </Box>

      <LauncherIcon />
    </Box>
  );
};
